import {
    BOOKINGS_CREATE_FOR_DEPOSIT_START,
    BOOKINGS_CREATE_FOR_DEPOSIT_SUCCESS,
    BOOKINGS_CREATE_START,
    BOOKINGS_CREATE_SUCCESS,
    BOOKINGS_ERROR,
    BookingsAction
} from 'actions/bookings/BookingsActionsTypes';
import { convertToBooking, convertToSaveBookingDto } from 'actions/bookings/BookingsConverter';
import { BookingDto } from 'actions/bookings/BookingsDtos';
import { BookingError, BookingErrorType } from 'actions/bookings/BookingsErrors';
import { ApiClient, createTokenConfig } from 'api/ApiClient';
import axios from 'axios';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';
import { RootAction } from 'types/Actions';
import { Booking, SaveBooking } from 'types/Booking';
import { getFirstAxiosError } from 'utils/axiosHelper';

const bookingsUrl = 'bookings';
const createForDepositsUrl = '/booking/create_for_deposits';

const errorHandler = (error: unknown): BookingsAction => {
    console.error(error);

    return {
        type: BOOKINGS_ERROR
    };
};

export const createBookingThunk =
    (bookingData: SaveBooking): ThunkAction<Promise<Booking>, RootState, null, RootAction> =>
    async (dispatch, getState) => {
        try {
            dispatch(bookingCreateStart());

            const marketplace = getState().marketplace.data;

            const response = await ApiClient.post(
                bookingsUrl,
                convertToSaveBookingDto(bookingData),
                {
                    ...createTokenConfig(),
                    params: {
                        marketplace_id: marketplace.id
                    }
                }
            );

            const booking = convertToBooking(response.data, marketplace.timeZone);

            dispatch(bookingCreateSuccess(booking));

            return booking;
        } catch (error) {
            dispatch(errorHandler(error));

            const errorMessage = getFirstAxiosError(error, 'Oops, something went wrong.');

            if (axios.isAxiosError(error)) {
                const data = error.response?.data;

                if ('appointments.booked_at' in data) {
                    throw new BookingError(BookingErrorType.AlreadyBooked);
                }
            }

            throw new BookingError(BookingErrorType.Unknown, errorMessage);
        }
    };

const bookingCreateStart = (): BookingsAction => {
    return {
        type: BOOKINGS_CREATE_START
    };
};

const bookingCreateSuccess = (booking: Booking): BookingsAction => {
    return {
        type: BOOKINGS_CREATE_SUCCESS,
        payload: {
            booking
        }
    };
};

export const createBookingForDepositThunk =
    (bookingData: SaveBooking): ThunkAction<Promise<Booking>, RootState, null, RootAction> =>
    async (dispatch, getState) => {
        dispatch(createForDepositStart());

        const marketplace = getState().marketplace.data;

        try {
            const response = await ApiClient.post<BookingDto>(
                createForDepositsUrl,
                convertToSaveBookingDto(bookingData),
                {
                    ...createTokenConfig(),
                    params: {
                        marketplace_id: marketplace.id
                    }
                }
            );

            const booking = convertToBooking(response.data, marketplace.timeZone);

            dispatch(createForDepositSuccess(booking));

            return booking;
        } catch (error) {
            dispatch(errorHandler(error));

            const errorMessage = getFirstAxiosError(error, 'Oops, something went wrong.');

            if (axios.isAxiosError(error)) {
                const data = error.response?.data;

                if ('appointments.booked_at' in data) {
                    throw new BookingError(BookingErrorType.AlreadyBooked);
                }
            }

            throw new BookingError(BookingErrorType.Unknown, errorMessage);
        }
    };

const createForDepositStart = (): BookingsAction => {
    return {
        type: BOOKINGS_CREATE_FOR_DEPOSIT_START
    };
};

const createForDepositSuccess = (booking: Booking): BookingsAction => {
    return {
        type: BOOKINGS_CREATE_FOR_DEPOSIT_SUCCESS,
        payload: {
            booking
        }
    };
};
